import { Link } from "react-router-dom";

export const Logo = ({ small = false }) => (
  <Link to="/" data-testid="brand-logo-link" className="group flex items-center gap-3">
    <span className="relative h-9 w-9 rounded-full vinyl-grooves border border-white/10 grid place-items-center group-hover:rotate-180 transition-transform duration-700">
      <span className="h-3 w-3 rounded-full bg-emerald-500 shadow-[0_0_12px_#10b981]" />
    </span>
    <span className="leading-none">
      <span className={`font-display font-black uppercase tracking-tighter block ${small ? "text-sm" : "text-sm sm:text-base"}`}>
        The Groove <span className="text-emerald-400">Anomaly</span>
      </span>
      <span className="font-mono-tga text-[10px] uppercase tracking-[0.4em] text-zinc-400">records</span>
    </span>
  </Link>
);
